import { FileUploadDesignTokens } from '@primeuix/themes/types/fileupload';

import { getRem } from '@customer-portal/shared/helpers/theme-utils';

export const fileUploadOverride: FileUploadDesignTokens = {
  content: {
    padding: `${getRem(8)} 0`,
    gap: '0',
  },
};
